import { IApplicationState } from '../types/redux';

export function breadcrumpsSelector(state: IApplicationState) {
  return state.newbuilding.breadcrumbs;
}
